/**
 * Date formatter — uses Admin App Settings when BrandingContext is available.
 */
import { useBranding } from "../context/BrandingContext";

const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

function pad(n) {
  return String(n).padStart(2, "0");
}

export function formatDateBySettings(inputDate, type = "full", settings = {}) {
  if (!inputDate) return "";
  const dateObj = new Date(inputDate);
  if (isNaN(dateObj)) return "Invalid Date";

  const day = pad(dateObj.getDate());
  const monthNum = pad(dateObj.getMonth() + 1);
  const year = dateObj.getFullYear();
  const monthShort = MONTHS[dateObj.getMonth()];
  const fmt = settings?.dateFormat || "DD MMM YYYY";

  let date;
  switch (fmt) {
    case "DD-MM-YYYY":
      date = `${day}-${monthNum}-${year}`;
      break;
    case "MM-DD-YYYY":
      date = `${monthNum}-${day}-${year}`;
      break;
    case "YYYY-MM-DD":
      date = `${year}-${monthNum}-${day}`;
      break;
    default:
      date = `${day} ${monthShort} ${year}`;
  }

  let hours = dateObj.getHours();
  const minutes = pad(dateObj.getMinutes());
  const seconds = pad(dateObj.getSeconds());
  let time;
  if (settings?.timeFormat === "24h") {
    time = `${pad(hours)}:${minutes}:${seconds}`;
  } else {
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    time = `${pad(hours)}:${minutes}:${seconds} ${ampm}`;
  }

  switch (String(type).toLowerCase()) {
    case "date":
      return date;
    case "time":
      return time;
    default:
      return `${date} ${time}`;
  }
}

export const autoDateFormat = (inputDate, type = "full") => {
  const settings =
    (typeof window !== "undefined" && window.__APP_SETTINGS__) || {};
  return formatDateBySettings(inputDate, type, settings);
};

export const useAutoDateFormat = () => {
  const { formatDate, settings } = useBranding();
  if (typeof window !== "undefined" && settings) {
    window.__APP_SETTINGS__ = settings;
  }
  return formatDate;
};
